import { getModels, addModel, editModel, deleteModel, getModelStatus } from './model-data';

export const WAIT_INIT_MODELS = 'WAIT_INIT_MODELS';
export const INIT_MODELS_SUCCESS = 'INIT_MODELS_SUCCESS';
export const INIT_MODELS_FAIL = 'INIT_MODELS_FAIL';
export const WAIT_QUERY_MODELS = 'WAIT_QUERY_MODELS';
export const EDIT_MODEL = 'EDIT_MODEL';
export const EDIT_MODEL_SUCCESS = 'EDIT_MODEL_SUCCESS';
export const EDIT_MODEL_FAIL = 'EDIT_MODEL_FAIL';
export const SAVE_MODEL_FORM = 'SAVE_MODEL_FORM';
export const SAVE_MODEL_FORM_SUCCESS = 'SAVE_MODEL_FORM_SUCCESS';
export const SAVE_MODEL_FORM_FAIL = 'SAVE_MODEL_FORM_FAIL';
export const SET_MODEL_DETAIL = 'SET_MODEL_DETAIL';
export const FORWARD_MODEL_DETAIL = 'FORWARD_MODEL_DETAIL';
export const GET_MODEL_DETAIL = 'GET_MODEL_DETAIL';
export const GET_MODEL_DETAIL_SUCCESS = 'GET_MODEL_DETAIL_SUCCESS';
export const GET_MODEL_DETAIL_FAIL = 'GET_MODEL_DETAIL_FAIL';
export const CLOSE_DETAIL_STATUS = 'CLOSE_DETAIL_STATUS';
export const DELETE_MODEL = 'DELETE_MODEL';
export const DELETE_MODEL_SUCCESS = 'DELETE_MODEL_SUCCESS';
export const DELETE_MODEL_FAIL = 'DELETE_MODEL_FAIL';

export const forwardModelList = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_MODELS
    });
}

export const initModelsData = (idToken, enabled) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getModels(resolve, reject, idToken, enabled);
    });

    doPost
    .then((data) => {
        let models = data.devices;

        dispatch({
            type: INIT_MODELS_SUCCESS,
            params: {
                models: models
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: INIT_MODELS_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });
};

export const queryDevices = () => (dispatch) => {
    dispatch({
        type: WAIT_QUERY_MODELS
    });
}

export const enableModal = (idToken, modelName,  enabled) => (dispatch) => {
    let objBody = {
        modelName: modelName
    };
    if (enabled) {
        objBody['Enabled'] = 1;
    } else {
        objBody['Enabled'] = 0;
    }

    const doPost = new Promise((resolve, reject) => {
        editModel(resolve, reject, idToken, objBody);
    });

    doPost
    .then((data) => {
        dispatch({
            type: EDIT_MODEL_SUCCESS
        });
    })
    .catch((err) => {
        dispatch({
            type: EDIT_MODEL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: EDIT_MODEL
    });
}

export const toggleSteamClean = (idToken, modelName,  checked) => (dispatch) => {
    let objBody = {
        modelName: modelName,
        formCheck: 1
    };
    if (checked) {
        objBody['steamClean'] = 1;
    } else {
        objBody['steamClean'] = 0;
    }

    const doPost = new Promise((resolve, reject) => {
        editModel(resolve, reject, idToken, objBody);
    });

    doPost
    .then((data) => {
        dispatch({
            type: EDIT_MODEL_SUCCESS
        });
    })
    .catch((err) => {
        dispatch({
            type: EDIT_MODEL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: EDIT_MODEL
    });
}

export const toggleAirQuality = (idToken, modelName,  checked) => (dispatch) => {
    let objBody = {
        modelName: modelName,
        formCheck: 1
    };
    if (checked) {
        objBody['airQuality'] = 1;
    } else {
        objBody['airQuality'] = 0;
    }

    const doPost = new Promise((resolve, reject) => {
        editModel(resolve, reject, idToken, objBody);
    });

    doPost
    .then((data) => {
        dispatch({
            type: EDIT_MODEL_SUCCESS
        });
    })
    .catch((err) => {
        dispatch({
            type: EDIT_MODEL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: EDIT_MODEL
    });
}

export const forwarModelDetail = () => (dispatch) => {
    dispatch({
        type: FORWARD_MODEL_DETAIL
    });
}

export const getModelDetail = (idToken, detailSeq) => (dispatch) => {
    let doGet = new Promise((resolve, reject) => {
        getModelStatus(resolve, reject, idToken, detailSeq);
    });
    
    doGet
    .then((data) => {
        // id success keep detail params
        window.sessionStorage.setItem('RangeHood.' + window.CONFIG.CACHE_MODEL, JSON.stringify({
            modelDetail: data
        }));

        dispatch({
            type: GET_MODEL_DETAIL_SUCCESS,
            params: {
                modelDetail: data
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: GET_MODEL_DETAIL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    // clear session detail data
    sessionStorage.removeItem('RangeHood.' + window.CONFIG.CACHE_MODEL);

    dispatch({
        type: GET_MODEL_DETAIL
    });
}

export const setModeDetail = (modelDetail) => (dispatch) => {
    // id success keep detail params
    window.sessionStorage.setItem('RangeHood.' + window.CONFIG.CACHE_MODEL, JSON.stringify({
        modelDetail: modelDetail
    }));

    dispatch({
        type: SET_MODEL_DETAIL,
        params: {
            modelDetail: modelDetail
        }
    });
}

export const saveModelForm = (type, idToken, bodyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        switch (type) {
            case 'NEW':
                addModel(resolve, reject, idToken, bodyObj);
                break;
            case 'EDIT':
                editModel(resolve, reject, idToken, bodyObj);
                break;
            default:
                reject({ message: 'No this save type.' });
        }
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            dispatch({
                type: SAVE_MODEL_FORM_SUCCESS
            });
        } else {
            dispatch({
                type: SAVE_MODEL_FORM_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: SAVE_MODEL_FORM_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: SAVE_MODEL_FORM
    });
}

export const removeModel = (idToken, modelName, models) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteModel(resolve, reject, idToken, modelName);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            let newModes = [];
            models.forEach(model => {
                if (model.modelName !== modelName) {
                    newModes.push(model);
                }
            });

            dispatch({
                type: DELETE_MODEL_SUCCESS,
                params: {
                    models: newModes
                }
            });
        } else {
            dispatch({
                type: DELETE_MODEL_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DELETE_MODEL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: DELETE_MODEL
    });
}

export const closeDetailStatus = () => (dispatch) => {
    dispatch({
        type: CLOSE_DETAIL_STATUS
    });
}